import { render, staticRenderFns } from "./UnreadMessageCount.vue?vue&type=template&id=50b039d4"
import script from "./UnreadMessageCount.vue?vue&type=script&lang=js"
export * from "./UnreadMessageCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports